export default __webpack_public_path__ + "static/media/activeCalendar.6a467e28.svg";